import type {Parser, Renderer, RendererThis, Token, Tokens} from 'marked';

interface CustomRenderer extends Renderer {
    extendedbr?: (token: Token) => string;
}

interface CustomParser extends Parser {
    renderer: CustomRenderer;
}

interface CustomRendererThis extends RendererThis {
    parser: CustomParser;
}

export const extendedBr = {
    name: 'extended_br',
    level: 'block',
    renderer(this: CustomRendererThis, token: Tokens.Generic) {
        if (this.parser.renderer.extendedbr) {
            return this.parser.renderer.extendedbr(token);
        }

        return '<p style="height: 8px; margin: 0;"></p>';
    },
};
